<template>
  <div>
    <div :id="modalId" class="ui basic tiny modal" >
      <div v-if="generatingPDF===true" class="ui icon header">
        <i class="ui loading spinner icon"></i>
        <div class="content">
          <h2>Generating Migraine Impact Reports</h2>
          <label :for="shortLinkId" class="ui teal label">{{ reportLanguage }}</label>
        </div>
      </div>

      <div v-if="generatingPDF===false" class="ui icon header">
        <i class="download icon"></i>
        <div class="content">
          <h2>Download Migraine Impact Reports</h2>
          <label :for="shortLinkId" class="ui teal label">{{ reportLanguage }}</label>
        </div>
      </div>

      <div style="text-align: center">
        <div :class="{ generating: generatingPDF, generated: !generatingPDF }"
             :disable="generatingPDF"
             class="ui small left icon right action input">
            <input type="text" :id="shortLinkId" :value="pdfShortLink">
            <i class="linkify icon"></i>
          <button @click="copyToClipboard"
                  :class="{ disabled: generatingPDF }"
                  class="ui small primary button">
            <i class="copy icon"></i>
            Copy Link
          </button>
        </div>

        <h4 v-if="generatingPDF===true" style="font-weight: normal">Please hold on…</h4>
        <h4 v-else-if="generatingPDF===false" style="font-weight: normal">PDF generated and ready for download</h4>

        <br>

        <div @click="hideModal"
             :class="{ generating: generatingPDF, generated: !generatingPDF, inverted: generatingPDF }"
             :disable="generatingPDF"
             class="ui left floated cancel button">
          <i class="cancel icon"></i>
          Cancel
        </div>

        <div @click="openInNewTab"
             :class="{ generating: generatingPDF, generated: !generatingPDF,  inverted: generatingPDF, green: !generatingPDF }"
             :disable="generatingPDF"
             class="ui right floated ok button" >
          <i class="download icon"></i>
          Download
        </div>
      </div>
    </div>

    <div :id="errorModalId" class="ui mini modal">
      <div class="header">
        <i class="exclamation triangle triangle icon"></i>
        Error encountered
      </div>

      <div class="content">
        <p>Failed to generate Migraine Impact Reports.</p>
        <p>To try again, click Retry.</p>
      </div>

      <div class="actions">
        <div class="ui left floated cancel button">
          <i class="cancel icon"></i>
          Cancel
        </div>
        <div @click="retryGenerateMIR" class="ui positive button">
          <i class="download icon"></i>
          Retry
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      generatingPDF: {
        required: true
      },
      pdfShortLink: {
        required: true
      },
      pdfLongLink: {
        required: true
      },
      language: {
        required: true
      }
    },
    data() {
      return {
        shortLinkId: 'short-link-' + this._uid
      }
    },
    computed: {
      modalId: function() {
        let modalId = 'generate-PDF-' + this._uid;
        this.$emit('modalId', modalId);
        return modalId;
      },
      errorModalId: function() {
        let errorModalId = 'error-modal-' + this._uid;
        this.$emit('errorModalId', errorModalId);
        return errorModalId;
      },
      reportLanguage: function() {
        switch (this.language) {
          case 'en':
            return 'English';
            break;
          case 'de':
            return 'Deutsch';
            break;
          default:
            return 'en';
        }
      }
    },
    methods: {
      openInNewTab: function() {
        if (this.generatingPDF === false && this.pdfLongLink !== null) {
          window.open(this.pdfLongLink, "_blank")
        }
        this.hideModal();
      },
      copyToClipboard: function() {
        if (this.generatingPDF === false && this.pdfShortLink !== null) {
          document.getElementById(this.shortLinkId).select();
          document.execCommand('copy');
        }
        this.hideModal();
      },
      retryGenerateMIR: function() {
        this.$emit('retryGenerateMIR');
      },
      hideModal: function() {
        $('#' + this.modalId).modal('hide');
      }
    },
    beforeDestroy() {
      let modals = [document.getElementById(this.modalId), document.getElementById(this.errorModalId)]
      modals.forEach((modal) => {
        if (modal !== null) { modal.remove() }
      });
    }
  }
</script>
<style scoped>
  .dimmed.dimmable > .ui.modals.dimmer.visible {
    display: flex !important;
  }
  .generating {
    /*visibility: hidden !important;*/
    opacity: 0 !important;
  }
  .generated {
    transition: opacity 0.5s !important;
    opacity: 1 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/patients/ModalGeneratePDF.vue